import React from 'react';
import { Avatar as MuiAvatar } from '@mui/material';
import { AVATAR_COLORS } from '../../types';

interface AvatarProps {
  initials: string;
  color?: string;
  size?: number;
}

const Avatar: React.FC<AvatarProps> = ({ initials, color = 'blue', size = 32 }) => (
  <MuiAvatar
    sx={{
      width: size,
      height: size,
      background: AVATAR_COLORS[color] || AVATAR_COLORS.blue,
      fontSize: size * 0.35,
      fontWeight: 700,
      flexShrink: 0,
    }}
  >
    {initials}
  </MuiAvatar>
);

export default Avatar;
